import script from "./SelectCardCom.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCardCom.vue?vue&type=script&setup=true&lang=js"

import "./SelectCardCom.vue?vue&type=style&index=0&id=5d8cebc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d8cebc6"]])

export default __exports__